import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/header_logo.svg'
import _imports_1 from '../../assets/instagram-white-icon.svg'
import _imports_2 from '../../assets/Twitter_X.webp'
import _imports_3 from '../../assets/footer_logo_mobile.svg'


const _withScopeId = n => (_pushScopeId("data-v-0a579f6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-footer" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-box-Desktop footer-box\" style=\"width:230px;\" data-v-0a579f6e><div data-v-0a579f6e><img src=\"" + _imports_0 + "\" class=\"footer-logo\" data-v-0a579f6e></div><div style=\"margin-top:40px;\" data-v-0a579f6e> Wove Technologies strives<br data-v-0a579f6e> to empower businesses and<br data-v-0a579f6e> communities through<br data-v-0a579f6e> cutting-edge hardware and<br data-v-0a579f6e> software solutions, fostering<br data-v-0a579f6e> a smarter, more<br data-v-0a579f6e> interconnected world.</div></div><div class=\"footer-box-Desktop footer-box\" style=\"width:230px;\" data-v-0a579f6e><div class=\"footer-title\" data-v-0a579f6e>Site Info</div><div style=\"margin-top:50px;\" data-v-0a579f6e><a class=\"footer-text footer-link pointer\" href=\"/\" data-v-0a579f6e>Home</a><a class=\"footer-text footer-link pointer tMgt8\" href=\"/contactUs\" data-v-0a579f6e>Contact Us</a><a class=\"footer-text footer-link pointer tMgt8\" href=\"/about\" data-v-0a579f6e>About Us</a></div></div>", 2)
const _hoisted_4 = {
  class: "footer-box-Desktop footer-box",
  style: {"width":"230px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-title" }, "Services", -1))
const _hoisted_6 = { style: {"margin-top":"50px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-box-Desktop footer-box\" style=\"width:230px;\" data-v-0a579f6e><div class=\"footer-title\" data-v-0a579f6e>Contact Us</div><div style=\"margin-top:30px;\" data-v-0a579f6e><div class=\"footer-contact-item\" data-v-0a579f6e><div class=\"footer-contact-title\" data-v-0a579f6e>Email:</div><a target=\"_blank\" href=\"mailto:contact@wovetech.co\" data-v-0a579f6e><div class=\"footer-text\" data-v-0a579f6e>contact@wovetech.co</div></a></div><div class=\"footer-contact-item\" data-v-0a579f6e><div class=\"footer-contact-title\" data-v-0a579f6e>Address:</div><a target=\"_blank\" href=\"https://maps.app.goo.gl/2RCbCcCNEGcWJeTAA\" data-v-0a579f6e><div class=\"footer-text\" data-v-0a579f6e>151 Yonge st, suite 1137<br data-v-0a579f6e> Toronto, ON, M5C 2W7. Canada</div></a></div><div class=\"footer-contact-item\" style=\"margin-top:40px;\" data-v-0a579f6e><a target=\"_blank\" href=\"https://www.instagram.com/wovetech/\" data-v-0a579f6e><img src=\"" + _imports_1 + "\" class=\"footer-icon\" data-v-0a579f6e></a><a target=\"_blank\" href=\"https://twitter.com/WoveTech\" data-v-0a579f6e><img src=\"" + _imports_2 + "\" class=\"footer-icon\" style=\"margin-left:37px;\" data-v-0a579f6e></a></div></div></div>", 1)
const _hoisted_9 = { class: "footer-line-box-Tablet" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-box-Tablet footer-box" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "footer-logo-Tablet"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"16px","opacity":"0.8"} }, [
    /*#__PURE__*/_createTextVNode(" Wove Technologies strives"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" to empower businesses"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" and communities through"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" cutting-edge hardware"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" and software solutions,"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" fostering a smarter, more"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" interconnected world.")
  ])
], -1))
const _hoisted_11 = {
  class: "footer-box-Tablet footer-box",
  style: {"margin-left":"73px"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-title" }, "Site Info", -1))
const _hoisted_13 = { style: {"margin-top":"24px","opacity":"0.8"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "footer-text footer-link pointer tMgt8",
  href: "/contactUs"
}, "Contact Us", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "footer-text footer-link pointer tMgt8",
  href: "/about"
}, "About Us", -1))
const _hoisted_16 = { class: "footer-line-box-Tablet footer-box" }
const _hoisted_17 = { class: "footer-box-Tablet footer-box" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-title" }, "Services", -1))
const _hoisted_19 = { style: {"margin-top":"24px","opacity":"0.8"} }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-box-Tablet footer-box\" style=\"margin-left:73px;\" data-v-0a579f6e><div class=\"footer-title\" data-v-0a579f6e>Contact Us</div><div style=\"margin-top:24px;opacity:0.8;\" data-v-0a579f6e><div class=\"footer-contact-item\" data-v-0a579f6e><div class=\"footer-contact-title\" data-v-0a579f6e>Email:</div><a target=\"_blank\" href=\"mailto:contact@wovetech.co\" data-v-0a579f6e><div class=\"footer-text\" data-v-0a579f6e>contact@wovetech.co</div></a></div><div class=\"footer-contact-item\" data-v-0a579f6e><div class=\"footer-contact-title\" data-v-0a579f6e>Address:</div><a target=\"_blank\" href=\"https://maps.app.goo.gl/2RCbCcCNEGcWJeTAA\" data-v-0a579f6e><div class=\"footer-text\" data-v-0a579f6e>151 Yonge st, suite 1137<br data-v-0a579f6e> Toronto, ON, M5C 2W7. Canada</div></a></div></div><div class=\"footer-contact-item\" style=\"margin-top:40px;\" data-v-0a579f6e><a target=\"_blank\" href=\"https://www.instagram.com/wovetech/\" data-v-0a579f6e><img src=\"" + _imports_1 + "\" class=\"footer-icon\" data-v-0a579f6e></a><a target=\"_blank\" href=\"https://twitter.com/WoveTech\" data-v-0a579f6e><img src=\"" + _imports_2 + "\" class=\"footer-icon\" style=\"margin-left:37px;\" data-v-0a579f6e></a></div></div>", 1)
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-box-Mobile footer-box" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      class: "footer-logo-Mobile"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"16px","opacity":"0.8","font-size":"16px","letter-spacing":"2px"} }, [
    /*#__PURE__*/_createTextVNode(" Wove Technologies strives"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" to empower businesses"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" and communities through"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" cutting-edge hardware"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" and software solutions,"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" fostering a smarter, more"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" interconnected world.")
  ])
], -1))
const _hoisted_23 = { class: "footer-box-Mobile footer-box tMgt40" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-title" }, "Services", -1))
const _hoisted_25 = { style: {"margin-top":"24px","opacity":"0.8","font-size":"16px","letter-spacing":"2px"} }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-box-Mobile footer-box tMgt65\" data-v-0a579f6e><div class=\"footer-title\" data-v-0a579f6e>Site Info</div><div style=\"margin-top:24px;opacity:0.8;font-size:16px;letter-spacing:2px;\" data-v-0a579f6e><a class=\"footer-text footer-link pointer\" href=\"/\" data-v-0a579f6e>Home</a><a class=\"footer-text footer-link pointer tMgt8\" href=\"/contactUs\" data-v-0a579f6e>Contact Us</a><a class=\"footer-text footer-link pointer tMgt8\" href=\"/about\" data-v-0a579f6e>About Us</a></div></div><div class=\"footer-box-Mobile footer-box tMgt65\" data-v-0a579f6e><div class=\"footer-title\" data-v-0a579f6e>Contact Us</div><div style=\"margin-top:24px;opacity:0.8;font-size:16px;letter-spacing:2px;\" data-v-0a579f6e><div class=\"footer-contact-item\" data-v-0a579f6e><div class=\"footer-contact-title\" data-v-0a579f6e>Email:</div><a target=\"_blank\" href=\"mailto:contact@wovetech.co\" data-v-0a579f6e><div class=\"footer-text\" data-v-0a579f6e>contact@wovetech.co</div></a></div><div class=\"footer-contact-item\" data-v-0a579f6e><div class=\"footer-contact-title\" data-v-0a579f6e>Address:</div><a target=\"_blank\" href=\"https://maps.app.goo.gl/2RCbCcCNEGcWJeTAA\" data-v-0a579f6e><div class=\"footer-text\" data-v-0a579f6e>151 Yonge st, suite 1137<br data-v-0a579f6e> Toronto, ON, M5C 2W7. Canada</div></a></div></div><div class=\"footer-contact-item\" style=\"margin-top:40px;\" data-v-0a579f6e><a target=\"_blank\" href=\"https://www.instagram.com/wovetech/\" data-v-0a579f6e><img src=\"" + _imports_1 + "\" class=\"footer-icon\" data-v-0a579f6e></a><a target=\"_blank\" href=\"https://twitter.com/WoveTech\" data-v-0a579f6e><img src=\"" + _imports_2 + "\" class=\"footer-icon\" style=\"margin-left:37px;\" data-v-0a579f6e></a></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", {
          class: "footer-text pointer footer-link",
          href: "/infrastructure",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.linkTo('/infrastructure', {})))
        }, "Infrastructure"),
        _createElementVNode("a", {
          class: "footer-text footer-link pointer tMgt8",
          href: "/buildingDevelopment",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.linkTo('/governmentAndEnterpriseOffice', {})))
        }, "New Building"),
        _createElementVNode("a", {
          class: "footer-text footer-link pointer tMgt8",
          href: "/existingBuilding",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.linkTo('/existingBuilding', {})))
        }, "Existing Building"),
        _createElementVNode("a", {
          class: "footer-text footer-link pointer tMgt8",
          href: "/iot",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.linkTo('/iot', {})))
        }, "IOT"),
        _createElementVNode("a", {
          class: "footer-text footer-link pointer tMgt8",
          href: "/software",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.linkTo('/software', {})))
        }, "Software"),
        _createElementVNode("a", {
          class: "footer-text footer-link pointer tMgt8",
          href: "/hardware",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.linkTo('/hardware', {})))
        }, "Hardware"),
        _createElementVNode("a", {
          class: "footer-text footer-link pointer tMgt8",
          href: "/meter",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.linkTo('/meter', {})))
        }, [
          _createTextVNode("Intelligent Watt-Hour"),
          _hoisted_7,
          _createTextVNode("Meter")
        ])
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("a", {
            class: "footer-text footer-link pointer",
            href: "/",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.linkTo('/', {})))
          }, "Home"),
          _hoisted_14,
          _hoisted_15
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("a", {
            class: "footer-text pointer footer-link",
            href: "/infrastructure",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.linkTo('/infrastructure', {})))
          }, "Infrastructure"),
          _createElementVNode("a", {
            class: "footer-text footer-link pointer tMgt8",
            href: "/buildingDevelopment",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.linkTo('/governmentAndEnterpriseOffice', {})))
          }, "New Building"),
          _createElementVNode("a", {
            class: "footer-text footer-link pointer tMgt8",
            href: "/existingBuilding",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.linkTo('/existingBuilding', {})))
          }, "Existing Building"),
          _createElementVNode("a", {
            class: "footer-text footer-link pointer tMgt8",
            href: "/iot",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.linkTo('/iot', {})))
          }, "IOT"),
          _createElementVNode("a", {
            class: "footer-text footer-link pointer tMgt8",
            href: "/software",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.linkTo('/software', {})))
          }, "Software"),
          _createElementVNode("a", {
            class: "footer-text footer-link pointer tMgt8",
            href: "/hardware",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.linkTo('/hardware', {})))
          }, "Hardware"),
          _createElementVNode("a", {
            class: "footer-text footer-link pointer tMgt8",
            href: "/meter",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.linkTo('/meter', {})))
          }, [
            _createTextVNode("Intelligent Watt-Hour"),
            _hoisted_20,
            _createTextVNode("Meter")
          ])
        ])
      ]),
      _hoisted_21
    ]),
    _hoisted_22,
    _createElementVNode("div", _hoisted_23, [
      _hoisted_24,
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("a", {
          class: "footer-text pointer footer-link",
          href: "/infrastructure",
          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.linkTo('/infrastructure', {})))
        }, "Infrastructure"),
        _createElementVNode("a", {
          class: "footer-text footer-link pointer tMgt8",
          href: "/buildingDevelopment",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.linkTo('/governmentAndEnterpriseOffice', {})))
        }, "New Building"),
        _createElementVNode("a", {
          class: "footer-text footer-link pointer tMgt8",
          href: "/existingBuilding",
          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.linkTo('/existingBuilding', {})))
        }, "Existing Building"),
        _createElementVNode("a", {
          class: "footer-text footer-link pointer tMgt8",
          href: "/iot",
          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.linkTo('/iot', {})))
        }, "IOT"),
        _createElementVNode("a", {
          class: "footer-text footer-link pointer tMgt8",
          href: "/software",
          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.linkTo('/software', {})))
        }, "Software"),
        _createElementVNode("a", {
          class: "footer-text footer-link pointer tMgt8",
          href: "/hardware",
          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.linkTo('/hardware', {})))
        }, "Hardware"),
        _createElementVNode("a", {
          class: "footer-text footer-link pointer tMgt8",
          href: "/meter",
          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.linkTo('/meter', {})))
        }, [
          _createTextVNode("Intelligent Watt-Hour"),
          _hoisted_26,
          _createTextVNode("Meter")
        ])
      ])
    ]),
    _hoisted_27
  ]))
}